export default "__VITE_ASSET__BH12Un4H__"